import { SxProps, Tooltip, Theme } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import theme from "theme";
import { ReactNode } from "react";

const DescriptionTooltip = ({ description, sx }: { description?: string | null | ReactNode; sx?: SxProps<Theme> }) => {
  if (!description) return <></>;

  return (
    <Tooltip title={description}>
      <InfoIcon
        fontSize="small"
        sx={{
          color: theme.palette.grey[200],
          ...sx,
        }}
      />
    </Tooltip>
  );
};

export default DescriptionTooltip;
